import React from "react";
import styled from "styled-components";
import { data } from "./Contents";
import { COLORS } from "../../Constants/colors";
import {
  SubHeading,
  ParagraphLg as Paragraph,
  Divider,
} from "../../Constants/typography";

const ContainerDiv = styled.div`
  box-sizing: border-box;
  @media screen and (max-width: 768px) {
    padding: 80px 20px 0;
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 40px;
  box-sizing: border-box;
  padding-bottom: 40px;

  @media screen and (max-width: 768px) {
    gap: 20px;
  }
`;

const HeadingCol = styled.div`
  flex: 1 1 100%;
`;

// const Col4 = styled.div`
//   flex: 1 1 calc(33.3333% - (2 * 40px / 3));
//   max-width: calc((7 / 12) * 100% - (40px * (5 / 12)));
//   border: 1px solid ${COLORS.secondary};
//   border-radius: 20px;
//   padding: 24px;
//   background-color: ${COLORS.cardBackground};
//   box-sizing: border-box;
//   box-shadow: ${COLORS.shadowColor};
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;

//   @media screen and (max-width: 768px) {
//     flex: 1 1 100%;
//     max-width: 100%;
//   }
// `;
const Col4 = styled.div`
  flex: 1 1 calc(33.3333% - (2 * 40px / 3));
  max-width: calc((7 / 12) * 100% - (40px * (5 / 12)));
  border-radius: 20px;
  padding: 24px;
  box-sizing: border-box;

  background: linear-gradient(
    135deg,
    rgba(15, 15, 15, 0.8) 20%,
    rgba(20, 20, 20, 0.7) 40%,
    rgba(40, 40, 40, 0.6) 70%,
    rgba(70, 70, 70, 0.4) 80%
  );
  border: 1px solid rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

const DescriptionText = styled(Paragraph)`
  font-size: 18px;
  color: ${COLORS.textPrimary};
  line-height: 28px;
  font-weight: 400;
  padding-bottom: 24px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

const ClientDiv = styled.div`
  display: flex;
  align-items: center;
`;

const ClientDetailsDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  color: ${COLORS.textPrimary};
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;

  span:first-child {
    font-weight: 600;
    color: ${COLORS.primary};
  }

  span:nth-child(2),
  span:nth-child(3) {
    font-weight: 400;
    color: ${COLORS.textSecondary};
  }
`;

const Testimonials = () => {
  return (
    <ContainerDiv>
      <Row>
        <HeadingCol>
          <SubHeading>TESTIMONIALS</SubHeading>
          <Divider />
        </HeadingCol>
      </Row>
      <Row>
        {data.map((item, index) => (
          <Col4 key={index}>
            <DescriptionText>{item.desc}</DescriptionText>
            <ClientDiv>
              <span>{item.icon}</span>
              <ClientDetailsDiv>
                <span>{item.client.name}</span>
                <span>{item.client.company}</span>
                <span>{item.client.country}</span>
              </ClientDetailsDiv>
            </ClientDiv>
          </Col4>
        ))}
      </Row>
    </ContainerDiv>
  );
};

export default Testimonials;
